const SCHEDULED_AUCTION_DESCRIPTION =
  "You can set a time when your auction will automatically start. If the auction ends without any bids " +
  "that meet the reserve price, the piece will go back to being listed at the reserve price. You can schedule " +
  "auctions at most 14 days ahead of time.";
export default SCHEDULED_AUCTION_DESCRIPTION;
